<script>
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	import {
		isMobile,
		isWideScreen,
		isMenuClosed,
		userEntity,
	} from './stores/variables';
	import { profileData } from './stores/data';

	import { request } from './scripts/request';
	import { logout } from './scripts/logout';

	import Wrapper from './svelte/main/Wrapper.svelte';

	//реализовать clinic_edit на 20 и 21 groupID без возможности добавления и передачи прав, только редактирование

	onMount(() => {
		request
			.fetchData('user-data', 'user-data', {}, { method: 'GET' })
			.then((result) => {
				$profileData = result;
				if (
					result.GroupID == 11 ||
					result.GroupID == 1 ||
					result.GroupID == 2 ||
					result.GroupID == 3
				) {
					$userEntity = 'clinic_moderator';
				} else if (
					result.GroupID == 10 ||
					result.GroupID == 20 ||
					result.GroupID == 21
				) {
					$userEntity = 'clinic_owner';
				} else if (result.GroupID == 19) {
					$userEntity = 'doctor';
				} else {
					alert('Вы не являетесь владельцем клиники или врачом');
					logout();
				}
			});

		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			)
		) {
			return ($isMobile = true);
		} else {
			return ($isMobile = false);
		}
	});

	const mql = window.matchMedia('(max-width: 991px)');
	function screenMatch(e) {
		if (e.matches) {
			$isWideScreen = false;
			$isMenuClosed = true;
			// $switchOrgs = false;
		} else {
			$isWideScreen = true;
			// $mobileClinicState = false;
			$isMenuClosed = false;
		}
	}
	mql.addEventListener('change', screenMatch);
	screenMatch(mql);
</script>

<svelte:head>
	<link rel="stylesheet" href="/fonts/FontAwesome/css/all.min.css" />
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	<link
		href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
		rel="stylesheet"
	/>
	<link
		href="https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap"
		rel="stylesheet"
	/>
</svelte:head>

{#if $userEntity}
	<Wrapper />
{:else}
	<div class="spin-wrapper" transition:fade={{ duration: 100 }}>
		<div class="spinner" />
	</div>
{/if}
